import { Spin } from 'antd'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { checkToken } from '../actions/auth'
import { TAG_KEY } from '../constants/local-storage-keys'
import { calcESTDay, getDayKeyFromDate } from '../sagas/lineup'

class Initializer extends Component {
  componentDidMount() {
    this.props.checkToken()
    // Set up local tag storage on init
    const dateKey = getDayKeyFromDate(calcESTDay())
    const savedTags = JSON.parse(localStorage.getItem(TAG_KEY))
    if (!savedTags || savedTags.date !== dateKey) localStorage.setItem(TAG_KEY, JSON.stringify({
      date: dateKey
    }))
  }

  render() {
    if (this.props.auth.loadingCheck) {
      return (
        <div style={{marginTop: '400px', textAlign: 'center'}}>
          <Spin />
        </div>
      )

    }
    return (
      <div>{ this.props.children }</div>
    )
  }
}

export default connect(
  state => ({
    auth: state.auth
  }),
  {
    checkToken: checkToken
  }
)(Initializer)
